import { OpenModalOptions } from './components/Modal/ModalProvider';

export const DATAGRID_ROW_HEIGHT = 52;
export const DATAGRID_PAGE_SIZE_OPTIONS = [25, 50, 100];
export const DATAGRID_DEFAULT_PAGE_SIZE = 50;
export const EMPTY_VALUE_PLACEHOLDER = '-';

export const STATUS_DOT_SIZE = 8;

export const REPEAT_OVERFLOW_COUNTER_AVATAR_DIM = {
  small: 24,
  medium: 32
} as const;

export const API_KEY_MAX_NAME_LENGTH = 48;
export const DEVICE_GROUP_NAME_MAX_LENGTH = 48;
export const VISITOR_NAME_MAX_LENGTH = 120;

const WIZARD_MODAL_MAX_WIDTH = 900;
const WIZARD_MODAL_WIDTH = '80vw';
export const WIZARD_MODAL_DEFAULT_OPTIONS: OpenModalOptions = {
  maxWidth: WIZARD_MODAL_MAX_WIDTH,
  width: WIZARD_MODAL_WIDTH
};
export const WIZARD_STEP_MIN_HEIGHT = 400;
